import DelegationAddRouteWaypoint from "../../../../types/delegation-add-route-waypoint";

const getPlaceLabel = (place: DelegationAddRouteWaypoint["place"]) => {
  if (place === null) {
    return `----`;
  }

  return place.displayName;
};

const getPlaceTitle = (place: DelegationAddRouteWaypoint["place"]) => {
  if (place === null) {
    return undefined;
  }

  return place.displayName;
};

const getGroupLabel = (group: DelegationAddRouteWaypoint["group"]) => {
  if (group === null) {
    return `----`;
  }

  return group;
};

const getGroupTitle = (group: DelegationAddRouteWaypoint["group"]) => {
  if (group === null) {
    return undefined;
  }

  return group;
};

const generateWaypointDotClassname = (waypoint: DelegationAddRouteWaypoint) => {
  return `dot-uuid-${waypoint.uuid}`;
};

const delegationAddSummaryRouteHelper = {
  getPlaceLabel,
  getPlaceTitle,
  getGroupLabel,
  getGroupTitle,
  generateWaypointDotClassname,
};

export default delegationAddSummaryRouteHelper;
